"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TransportService {
    constructor(connectionsPool, transactionSerializer, namespace) {
        this.onIncomingTransactionsCallbacks = [];
        this.connectionsPool = connectionsPool;
        this.transactionSerializer = transactionSerializer;
        this.namespace = namespace;
        this.connectionsPool.addOnMessageCallback((message, peerId) => {
            console.log('Incoming message', new Blob([message]).size, peerId);
            try {
                const data = JSON.parse(message);
                if (!data || !data.ns || !data.type) {
                    // noinspection ExceptionCaughtLocallyJS
                    throw new Error('Cannot parse message');
                }
                if (data.ns !== this.namespace) {
                    // noinspection ExceptionCaughtLocallyJS
                    throw new Error('Different namespace');
                }
                if (data.type === 'txs' && data.txsData && data.txsData.length) {
                    const transactions = [];
                    for (const txData of data.txsData) {
                        transactions.push(this.transactionSerializer.dataToTransaction(txData, false));
                    }
                    if (transactions.length) {
                        for (const callback of this.onIncomingTransactionsCallbacks) {
                            callback(transactions);
                        }
                    }
                }
            }
            catch (e) {
                console.log('Cannot parse message from ' + peerId + ': ' + e.toString());
            }
        });
    }
    send(transactions) {
        const serializedTransactions = [];
        for (const tx of transactions) {
            serializedTransactions.push(this.transactionSerializer.transactionToData(tx, false));
        }
        const message = JSON.stringify({
            ns: this.namespace,
            type: 'txs',
            txsData: serializedTransactions
        });
        this.connectionsPool.sendMessage(message);
    }
    addOnIncomingTransactionsCallback(callback) {
        this.onIncomingTransactionsCallbacks.push(callback);
    }
}
exports.TransportService = TransportService;
